import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { createNotification } from "./Popup";
import { getAppId, getEmail, setAddressInfo, setDeclarationInfo, setQrVerificationInfo, setTravelInfo } from "../utility/Common";
import { messages } from "../utility/services/message";

const DeclarationReusableComponent = ({ applicationManagement }) => {
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();

  const handleApplicationManagement = (payload, url) => {
    setIsLoading(true);
    if (url == "declaration") {
      const newPayload = {
        ApplicationId: getAppId(),
        EmailAddress: getEmail()
      }
      applicationManagement(newPayload, url)
        .then((result) => {
          if (result.code == 1) {
            switch (url) {
              case "add-address-info":
                setAddressInfo(result?.data[0])
                navigate("/anuani_ya_sasa");
                break
              case "add-travel-info":
                setTravelInfo(result?.data[0])
                navigate("/taarifa_za_safari");
                break
              case "declaration":
                setDeclarationInfo(result?.data)
                navigate("/selfDeclaration");
                break
              default: navigate("/continue");
            }

          } else if (result.code == 3) {
            sessionStorage.clear()
            localStorage.clear()
            navigate("/continue")
          } else {
            const info = { type: "error", message: result.message };
            createNotification(info)();
          }
        })
        .catch((error) => {
          const info = { type: "error", message: messages.networkError };
          createNotification(info)();
        });
    } else {
      const newPayload = {
        Action: payload.Action,
        HouseNumber: payload?.HouseNumber,
        ResidenceDistrictID: payload?.ResidenceDistrictID,
        ResidenceVillage: payload?.ResidenceVillage,
        TravellingPurposeID:"",
        CountryID:"",
        OccupationID:"",
        ApplicationId: getAppId(),
        EmailAddress: getEmail()
      }


      applicationManagement(newPayload, url)
        .then((result) => {
          if (result.code == 1) {
            switch (url) {
              case "add-address-info":
                setAddressInfo(result?.data[0])
                navigate("/anuani_ya_sasa");
                break
              case "add-travel-info":
                setTravelInfo(result?.data[0])
                navigate("/taarifa_za_safari");
                break
              case "declaration":
                setDeclarationInfo(result?.data)
                navigate("/selfDeclaration");
                break
                case "check_etd":
                  setQrVerificationInfo(result?.data)
                  navigate("/qrverification", { state: result?.data });
                  break
              default: navigate("/continue");
            }

          } else if (result.code == 3) {
            sessionStorage.clear()
            localStorage.clear()
            navigate("/continue")
          } else {
            const info = { type: "error", message: result.message };
            createNotification(info)();
          }
        })
        .catch((error) => {
          const info = { type: "error", message: messages.networkError };
          createNotification(info)();
        });

    }


  };

  return { isLoading, handleApplicationManagement };
};

export default DeclarationReusableComponent;
